import React, { useEffect, useState, useLayoutEffect } from 'react'
import { useTable, useExpanded, useBlockLayout } from 'react-table'
import { useSticky } from "react-table-sticky";
import styled from 'styled-components'
import { FixedSizeList } from "react-window";
import { observer } from "mobx-react";
import myGrid from '../../store/myGridStore';
import useIsMobile from '../../util/useIsMobile';
const Styles = styled.div`
    /* This is required to make the table full-width */
    display: block;
    max-width: 100%;
    .table {
        background: #fff;
        border: 1px solid #d4d4d4;

        .explain-row {
            .td:not(#cell_total, #cell_space) {
                width: 880px !important;
                border-right: none!important;
            }
            #cell_space,
            #cell_total {
                width: 170px!important;
                border-right: none;
            }
        }

        .header {
            font-weight: bold;
            background: #f8f8f8;
            height: 30px;
            box-shadow: none !important;
            .th {
                background: #f8f8f8;
            }
        }

        .tr {
            width: auto !important;
            min-width: 100%;
            :last-child {
                .td {
                    border-bottom: 0;
                }
            }
        }
        .th,
        .td {
            padding: 5px;
            border-bottom: 1px solid #ddd;
            border-right: 1px solid #ddd;
            background-color: #fff;
            overflow: hidden;
            :last-child {
                border-right: 0;
            }
            :not([data-sticky-td]) {
                flex-grow: 1;
            }
            .resizer {
                display: inline-block;
                width: 5px;
                height: 100%;
                position: absolute;
                right: 0;
                top: 0;
                transform: translateX(50%);
                z-index: 1;
                &.isResizing {
                    background: red;
                }
            }
        }

        &.sticky {
            overflow: hidden;
            .header,
            .footer {
                position: sticky;
                z-index: 1;
                width: fit-content;
                min-width: 100%;
            }
            .header {
                top: 0;
                box-shadow: 0px 3px 3px #ccc;
                z-index: 1;
            }
            .footer {
                bottom: 0;
                box-shadow: 0px -3px 3px #ccc;
            }
            .body {
                position: relative;
                z-index: 0;
            }
            .table-body {
                .tr:nth-child(2n) {
                    background-color: #f9f9f9;
                }
                .tr:nth-child(2n) .td {
                    background-color: #f9f9f9;
                }
                .tr:last-child {
                    border-bottom: 1px solid #ccc;
                }
                .tr:hover .td {
                    background-color: #eff9fc !important;
                }
                .tr .td {
                    border-bottom: none;
                }
            }
            [data-sticky-td] {
                position: sticky;
            }
            [data-sticky-last-left-td] {
                box-shadow: 2px 0px 0px #ccc;
            }
            [data-sticky-first-right-td] {
                box-shadow: -2px 0px 3px #ccc;
            }
            .explain-row > .td {
                background :  hsl(47,65%,84%)!important;
            }
        }

        .Jyuf105 {
            > .td {
                &.processed {
                    color: #0275FF;
                    }
                &.unprocessed {
                    color: #ff0000;
                }
            }
        }

        @media screen and (max-width: 992px) {
            background-color: #fff;
            height: auto;
            max-height: initial;
            .cell-right {
                justify-content: space-between !important;
            }
            .header {
                display: none;
            }
        }
    }
`;


let prevScreenHeight = window.screen.height;
let prevOutSide = 0;
const CustomGrid = observer((props) => {
    // 画面幅を判定
    const isMobile = useIsMobile();

    const updateMyEdits = (rowIndex, columnId, value) => {
        // check if edit is in array
        if (props.data.length > 0) {
            props.data.map((row, index) => {
                if (index === rowIndex) {
                    row[columnId] = value;
                    return;
                }
            });
            myGrid.props.data = props.data;
        }
    };

    // Default setting column
    const defaultColumn = React.useMemo(
        () => ({
            maxWidth: 400,
            rowHeight: 20,
            headerHeight: 20
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
    } = useTable(
        {
            columns: myGrid.props.columnDefs,
            data: props.data,
            autoResetPage: false,
            updateMyEdits: updateMyEdits,
            autoResetExpanded: false,
            expandSubRows: true,
            defaultColumn: defaultColumn,
        },
        useExpanded,
        useBlockLayout,
        useSticky
    );

    const [heightGrid, setHeightGrid] = useState(window.innerHeight - prevOutSide);
    const [isDefaultHeight, setIsDefaultHeight] = useState(false);

    function setHeight(isWindowResize) {
        const minColumsDefault = 5;
        let windowResize = false;
        if (prevScreenHeight != window.screen.height) {
            windowResize = true;
            prevScreenHeight = window.screen.height;
        } else {
            windowResize = false;
        }
        if (props && props.customItemSize && prevOutSide) {
            if ((isWindowResize && !windowResize)) return;
            let minColums = props.minColumns ? props.minColumns : minColumsDefault;
            setHeightGrid((window.innerHeight - prevOutSide) < props.customItemSize * minColums ? props.customItemSize * minColums : (window.innerHeight - prevOutSide));
            setIsDefaultHeight((window.innerHeight - prevOutSide) < props.customItemSize * minColums);
        }
    }

    useEffect(() => {
        if (props.outsideHeight !== prevOutSide) {
            prevOutSide = props.outsideHeight;
            setHeight(false);
        }
    }, [props.outsideHeight, prevOutSide]);

    useEffect(() => {
        myGrid.props.data = props.data;

        function listener(event) {
            setHeight(true);
        }
        setHeight(false);
        window.addEventListener('resize', listener);
        return () => {
            window.removeEventListener('resize', listener);
        }
    }, []);

    useEffect(() => {
        if (!myGrid.props.expanded) return;
        state.expanded = myGrid.props.expanded;
    }, [myGrid.props.expanded]);

    useEffect(() => {
        const onKeydown = (e) => {
            if (e.code === "ArrowDown") {
                focusArrowUPDown(e.target, 1);
            }
            else if (e.code === "ArrowUp") {
                focusArrowUPDown(e.target, null);
            }

            if (e.code === 'F2') {
                Array.prototype.slice.call(getInput()).forEach(inputE => {
                    if (inputE.type !== 'checkbox') {
                        if (inputE.disabled) {
                            inputE.disabled = false;
                        } else {
                            inputE.setAttribute('disabled', 'disabled');
                        }
                    }
                })
            }
        };
        document.addEventListener("keydown", onKeydown);
        return () => {
            document.removeEventListener("keydown", onKeydown);
        };
    }, [rows]);

    useEffect(() => {
        const onKeyup = (e) => {
            if (!e.shiftKey && e.code === 'Enter') {
                focusKeyEnter(e.target, 1);
            }
            if (e.shiftKey && e.code === 'Enter') {
                focusKeyEnter(e.target, null);
            }
        };
        document.addEventListener("keyup", onKeyup);
    }, [rows]);

    function focusArrowUPDown(target, pressMode) {
        const cell = getCellByTag(target);
        if (!cell) return;
        if (pressMode === 1) {
            focusNextSiblingCell(cell, cell.id, null);
        } else {
            focusPreSiblingCell(cell, cell.id, null);
        }
    }

    function focusKeyEnter(target, pressMode) {
        const cell = getCellByTag(target);
        if (!cell) return;
        if (pressMode === 1) {
            if (cell.nextSibling) {
                focusElementNext(cell.nextSibling);
            } else {
                focusNextSiblingCell(cell, cell.id, 'Enter');
            }
        } else {
            if (cell.previousSibling) {
                focusElementPre(cell.previousSibling);
            } else {
                focusPreSiblingCell(cell, cell.id, 'Enter');
            }
        }
    }

    function getCellByTag(tag) {
        const cell = tag.parentNode;
        if (checChildren(cell, getTable())) {
            if (!Array.prototype.slice.call(getAllCellsTables()).filter(c => { return c === cell }).length) {
                return getCellByTag(cell);
            }
            return cell;
        }
        return null;
    };

    function getAllCellsTables() {
        const tableElement = document.getElementById('data-table');
        return tableElement.querySelectorAll('.cell_row');
    }

    function getRowByCell(cell) {
        return cell.parentNode;
    };

    function getInput() {
        return getTable().querySelectorAll('input');
    }

    function getTable() {
        return document.getElementById('data-table');
    }

    function checChildren(child, parent) {
        if (parent !== child && parent.contains(child)) {
            return true;
        }
        return false;
    }

    function getNextSiblingRow(cell) {
        const rowFrom = getRowByCell(cell);
        const index = Number(rowFrom.id.split('_')[1]) + 1;
        return getTable().querySelector(`#row_${index}`);
    }

    function getPreSiblingRow(cell) {
        const rowFrom = getRowByCell(cell);
        const index = Number(rowFrom.id.split('_')[1]) - 1;
        return getTable().querySelector(`#row_${index}`);
    }

    function focusNextSiblingCell(cell, id, mode) {
        const row = getNextSiblingRow(cell);
        if (row) {
            let cellFocus = null;
            cellFocus = row.children[0];
            if (mode !== 'Enter' && Array.prototype.slice.call(row.children).find(x => x.id === id)) {
                cellFocus = Array.prototype.slice.call(row.children).find(x => x.id === id);
            }
            focusElementNext(cellFocus, id, mode);
        } else {
            if (mode !== 'Enter') {
                return;
            }
            for (let i = 0; i < getAllElementScreen().length - 1; i++) {
                const item = getAllElementScreen()[i];
                if (item === getTable()) {
                    if (!checChildren(getAllElementScreen()[i + 1], getTable())) {
                        focusE(getAllElementScreen()[i + 1]);
                        break;
                    } else {
                        for (let j = i + 1; j < getAllElementScreen().length; j++) {
                            if (!checChildren(getAllElementScreen()[i + 1], getTable())) {
                                focusE(getAllElementScreen()[i + 1]);
                                break;
                            }
                        }
                        focusE(getAllElementScreen()[0]);
                        break;
                    }
                }
            }
        }
    }

    function focusPreSiblingCell(cell, id, mode) {
        const row = getPreSiblingRow(cell);
        if (row) {
            let cellFocus = row.children[row.children.length - 1];
            if (mode !== 'Enter' && Array.prototype.slice.call(row.children).find(x => x.id === id)) {
                cellFocus = Array.prototype.slice.call(row.children).find(x => x.id === id);
            }
            focusElementPre(cellFocus, id, mode);
        } else {
            if (mode !== 'Enter') {
                return;
            }
            Array.prototype.slice.call(getAllElementScreen()).forEach((item, i) => {
                if (item === getTable()) {
                    focusE(getAllElementScreen()[i - 1]);
                }
            });
        }
    }

    function focusElementNext(element, id = null, mode = null) {
        const elementFocus = element ? element.querySelector(['input', 'button', 'select']) : null;
        if (elementFocus && !elementFocus.disabled) {
            focusE(elementFocus);
        } else if (element && element.nextSibling) {
            focusElementNext(element.nextSibling)
        } else {
            focusNextSiblingCell(element, id, mode);
        }
    }

    function focusElementPre(element, id, mode = null) {
        const elementFocus = element ? element.querySelector(['input', 'button', 'select']) : null;
        if (elementFocus && !elementFocus.disabled) {
            focusE(elementFocus);
        } else if (element && element.previousSibling) {
            focusElementPre(element.previousSibling)
        } else {
            focusPreSiblingCell(element, id, mode);
        }
    }

    function getAllElementScreen() {
        return document.querySelectorAll(['input', 'button', 'select', '#data-table']);
    };

    function focusE(element) {
        setTimeout(() => {
            element.focus();
        }, 0);
    }

    const RenderRow = React.useCallback(
        ({ index, style }) => {
            const row = rows[index];
            prepareRow(row);
            const sum = row.original.sum;
            if (row.subRows && row.subRows.length) {
                return (
                    <div key={`group_${index}`} id={`group_${row.id}`} {...row.getRowProps({ style })} className="explain-row tr">
                        <div className="td cell_row" colSpan={row.cells.length} {...row.cells[0].getCellProps()}>{row.cells[0].render("Cell")}</div>
                        <div id="cell_space" className="td cell_row"></div>
                        {row.cells[0].column.toggle ? <div id="cell_total" className={`td cell_row ${row.cells[0].column.className}`}>{sum}</div> : ''}
                    </div>
                );
            } else {
                return (
                    <div key={`row_${index}`} id={`row_${index}`} {...row.getRowProps({ style })} className={`tr ${props.customClass ? props.customClass : ''}`}>
                        {row.cells.map((cell, i) => {
                            return (
                                <div key={`cell_${i}`} id={`cell_${cell.column.id}_${i}`} data-label={row.cells[i].column.Header} className={`td cell_row ${cell.column.className} ${(cell.column.id == 'jkyo') ? (cell.value == '未処理' ? 'unprocessed' : 'processed') : ''}`} {...cell.getCellProps(cell.row.original.add ? { style: { backgroundColor: "#31b0d5" } } : '')}>{cell.render("Cell")}</div>
                            );
                        })}
                    </div>
                );
            }
        },
        [prepareRow, rows]
    );

    // Render the UI for your table
    return (
        < Styles expanded="true">
            <div id="data-table"
                {...getTableProps()}
                className="table sticky" tabIndex="-1"
            >
                <FixedSizeList
                    height={isMobile ? props.outsideHeight ? heightGrid : props.tableHeight : props.outsideHeight ? heightGrid : props.tableHeight - 35}
                    itemCount={rows.length}
                    itemSize={props.customItemSize && isMobile ? props.customItemSize : 35}
                    width={"100%"}
                    style={{ willChange: "contents" }}
                    className={isDefaultHeight ? "grid-default-height" : ""}
                    innerElementType={({ children, style }) => (
                        <>
                            <div className="header">
                                {headerGroups.map(headerGroup => (
                                    <div {...headerGroup.getHeaderGroupProps()} className="tr">
                                        {headerGroup.headers.map(column => (
                                            <div {...column.getHeaderProps({ style: { minWidth: column.minWidth, width: column.width }, })} className="th">
                                                {column.render("Header")}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <div {...getTableBodyProps()} id="table-body" style={style} className="body table-body">{children}</div>
                        </>
                    )}
                >
                    {RenderRow}
                </FixedSizeList>
            </div>
        </Styles >
    )
})

export default CustomGrid;